<template>

  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Custom Cleareance Import Details</b-navbar-brand>
        </b-navbar>
        <!-- <b-container>
          <div>
            <b-button @click="viewFFExportFCL('1')" size="sm" variant="info">Pre-Alert Date
              <b-badge variant="light">{{this.pending_preAlrt_Count}}</b-badge>
            </b-button>
            <b-button @click="viewFFExportFCL('2')" size="sm" variant="info">Vessel-ETA
              <b-badge variant="light">{{this.pending_vesselEta_Count}}</b-badge>
            </b-button>
            <b-button @click="viewFFExportFCL('3')" size="sm" variant="info">Vessel Arrival Date
              <b-badge variant="light">{{this.pending_VesselArrive_Count}}</b-badge>
            </b-button>
            <b-button @click="viewFFExportFCL('4')" size="sm" variant="info">ICD Arrival Date
              <b-badge variant="light">{{this.pending_icdArrive_Count}}</b-badge>
            </b-button>
            <b-button @click="viewFFExportFCL('5')" size="sm" variant="info">Rail Out Date
              <b-badge variant="light">{{this.pending_railOut_Count}}</b-badge>
            </b-button>
            <b-button @click="viewFFExportFCL('6')" size="sm" variant="info">Do Date
              <b-badge variant="light">{{this.pending_Do_Count}}</b-badge>
            </b-button>
          </div>
          <div class="gutr">
            <b-button @click="viewFFExportFCL('7')" size="sm" variant="info">Out Of Charge Date
              <b-badge variant="light">{{this.pending_outCharge_Count}}</b-badge>
            </b-button>
            <b-button @click="viewFFExportFCL('8')" size="sm" variant="info">Icd Out Date
              <b-badge variant="light">{{this.pending_icdOut_Count}}</b-badge>
            </b-button>
            <b-button @click="viewFFExportFCL('9')" size="sm" variant="info">Empty Return Date
              <b-badge variant="light">{{this.pending_emptyR_Count}}</b-badge>
            </b-button>
          </div>
        </b-container>-->
        <div>
          <!-- <div >
    <md-layout md-gutter class="gutr">
            <md-layout md-flex="70"></md-layout>
 <md-layout md-flex="30">
                    <label for="containerTypeId">Billing Status</label>
                    <model-list-select
                      @input="viewFFExportFCL('0', '0', '1', '1');"
                      :list="invoiceStatusList"
                  v-model="billingFilter"
                      option-value="inv"
                      option-text="int"
                      placeholder="Select Status"
                    ></model-list-select>
    </md-layout>
    </md-layout>

</div> -->

          <div class="row mt-4 mb-3">
            <div class="col-md-7">
              <b-form-group>
                <b-input-group>
                  <b-form-input
                    :formatter="capitalizeAll"
                    v-model="filter"
                    @input="debounceSearch"
                    placeholder="Type To Search"
                  />
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <model-list-select
                @input="viewFFExportFCL('0', '0', '1', '1')"
                :list="invoiceStatusList"
                v-model="billingFilter"
                option-value="inv"
                option-text="int"
                placeholder="Select Status"
              ></model-list-select>
            </div>
            <div class="col-md-2">
                <model-list-select
                  @input="viewFFExportFCL('Normal', '0', '0', '1', '1')"
                  :list="dateStatusList"
                  v-model="dateStatusFilter"
                  option-value="inv"
                  option-text="int"
                  placeholder="Select Date Filter"
                ></model-list-select>
              </div>
            <div class="mt-2">
              <h5 class="text-muted pull-right mt-2 ml-3">
                <small v-if="isLoading == false">{{ totalRows }} Entries</small>
              </h5>
            </div>
          </div>
          <!-- <md-layout md-gutter class="gutr">
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="90">
                  <b-form-input :formatter="capitalizeAll" v-model="filter" placeholder="Search Custom Clearence Assignment"></b-form-input>
                </md-layout>
          </md-layout>-->
          <div class="table-responsive tableMain">
            <b-table
              show-empty
              stacked="md"
              :items="AirImportData"
              :fields="fields"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
            >
              <template slot="seenExec" slot-scope="row0">
                <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
              </template>
              <template slot="ccImportSeries" slot-scope="row1">
                <b
                  :style="row1.item.seenExec == '0' ? 'color:red' : 'color:black'"
                  @click="
                    row1.item.is_locked == '1' &&
                    (row1.item.finalBillingCompleted == 1 ||
                      row1.item.locked_counter > 0) &&
                    $sessionsStorage.get('designation') != 'Admin' &&
                    $sessionsStorage.get('nameUser') != 'Bhavneesh'
                      ? ''
                      : viewExportAirPage(row1.item)
                  "
                  class="showMoreData"
                  >{{ row1.item.ccImportSeries }}</b
                >
                <br />
                <span>Assignment Dt. : {{ row1.item.dateAssignment | moment }}</span>

                <br />
                <span>Raised From : {{ row1.item.raisedFrom }}<br /></span>
                <span>By : {{ row1.item.raisedBy }}<br /></span>
                <h7 class="mt-2" v-if="row1.item.splitFromId != '0'"
                  ><b-badge variant="info"
                    >Split of {{ row1.item.splitFromNo }}<br
                  /></b-badge>
                </h7>

                <b-button
                  style="font-size: 0.675rem"
                  class="mt-2"
                  size="sm"
                  @click="
                    row1.item.is_locked == '1' &&
                    (row1.item.finalBillingCompleted == 1 || row1.item.locked_counter > 0)
                      ? LockUnLock(row1.item, 'locked')
                      : ''
                  "
                  :variant="
                    row1.item.is_locked == '1' &&
                    (row1.item.finalBillingCompleted == 1 || row1.item.locked_counter > 0)
                      ? 'danger'
                      : 'success'
                  "
                  ><b
                    v-if="
                      row1.item.is_locked == '1' &&
                      (row1.item.finalBillingCompleted == 1 ||
                        row1.item.locked_counter > 0)
                    "
                    ><i class="fa fa-lock mr-1 lg"></i>LOCKED</b
                  ><b v-else><i class="fa fa-unlock mr-1 lg"></i>UN-LOCKED</b></b-button
                ><br />
                <b-button
                  class="mt-2"
                  style="font-size: 0.675rem"
                  size="sm"
                  @click="showDocModal(row1.item)"
                  variant="outline-info"
                  >Summary & Documents</b-button
                >
                <Assignment-Summary
                  :title="'Shipment Summary Tracking - '"
                  :fk_all_module_id="row1.item.allModuleId"
                  :jb_series="row1.item.ccImportSeries"
                />
                <ContainerSummary
                v-if="row1.item.allModuleId"
                :PMC_title="'Container Summary Job No - ' + row1.item.ccImportSeries"
                :PMC_JOBID="row1.item.allModuleId"
                :PMC_JOBNO="row1.item.ccImportSeries"
                :PMC_JOBDATE="''"
                :PMC_JOBTYPE="''"
                :PMC_AgentType="''"
                :PMC_Client="''"
                :PMC_Sline="''"
              />
              <!-- <JobWisePaymentsDetails
                  v-if="row1.item.allModuleId"
                  :allModuleId="Number(row1.item.allModuleId)"
                  :JobNo="row1.item.ccImportSeries"
                  /> -->
              <RejectInvTallyBillSummary
                v-if="row1.item.allModuleId"
                :PMC_title="'Invoice Rejection Log Summary Job No - ' + row1.item.ccImportSeries"
                :PMC_JOBID="row1.item.allModuleId"
                :PMC_JOBNO="row1.item.ccImportSeries"
                :PMC_JOBDATE="''"
                :PMC_JOBTYPE="''"
                :PMC_Client="''"
                :PMC_Sline="''"
              />
              <MSDeleteRequest
                :item="row1.item"
                :JobNo="row1.item.ccImportSeries"
                :JobID="row1.item.allModuleId"
                :sessionsStorage="$sessionsStorage"
                @refreshData="handleRefresh"
              />
              <b v-if="row1.item.deleteRequestBy != '' && row1.item.deleteRequestBy != '0' && row1.item.deleteRequestBy != null">Requested By : {{ row1.item.deleteRequestBy }}<br/></b>
              <b v-if="row1.item.deleteArrovedBy != '' && row1.item.deleteArrovedBy != '0' && row1.item.deleteArrovedBy != null">Arroved By : {{ row1.item.deleteArrovedBy }}<br/></b>
              
              </template>
              <template slot="ContainerNo" slot-scope="row5">
                <div v-if="row5.item.newContainerFlow == '1'">
                  <div v-if="row5.item.newContainers">
                    <div v-if="row5.item.newContainers">
                      <span
                        v-for="(item1, index) in row5.item.newContainers.split(',')"
                        :key="index"
                      >
                        <h6>
                          <b-badge variant="light">{{
                            item1 == "" ? "-------" : item1
                          }}</b-badge>
                        </h6>
                      </span>
                    </div>
                  </div>
                  <div v-else>
                    <b-badge variant="light">-------</b-badge>
                  </div>
                </div>
                <div v-else>
                  <div v-if="row5.item.ContainerNo != null">
                    <div v-if="row5.item.ContainerNo != null">
                      <span
                        v-for="(item1, index) in row5.item.ContainerNo.split(',')"
                        :key="index"
                      >
                        <h6>
                          <b-badge variant="light">{{
                            item1 == "" ? "-------" : item1
                          }}</b-badge>
                        </h6>
                      </span>
                    </div>
                  </div>
                  <div v-else>
                    <b-badge variant="light">-------</b-badge>
                  </div>
                </div>
                <!-- <span>
                BOE NO : {{ row5.item.BOE_NO }}
                <br />
              </span> -->
                <!-- <span>
                BOE Date : {{ row5.item.BOE_Date }}
                <br />
              </span> -->
              </template>

              <template slot="shippingBillNo" slot-scope="row34">
                <span>
                  BOE NO : {{ row34.item.shippingBillNo }}
                  <br />
                </span>
                <span>
                  BOE Date : {{ row34.item.BOE_Date }}
                  <br />
                </span>
              </template>
              <template slot="invoiceStatus" slot-scope="row33">
                <!-- <span>
                BOE NO : {{ row33.item.BOE_NO }}
                <br />
              </span>
              <span>
                BOE Date : {{ row33.item.BOE_Date }}
                <br />
              </span> -->
                <b
                  :style="
                    row33.item.invoiceStatus == '0'
                      ? { color: 'green' }
                      : { color: 'red' }
                  "
                  >{{
                    !row33.item.invoiceStatus
                      ? "--"
                      : row33.item.invoiceStatus == "1"
                      ? "In-Progress"
                      : row33.item.invoiceStatus == "0"
                      ? "Sent To Accounts"
                      : "--"
                  }}</b
                >

                <b v-if="row33.item.sentForApproval && row33.item.sentForApproval == '1'">
                  <br />
                  Sent for Approval
                </b>
                <b
                  v-if="
                    row33.item.chnageApprovalStatus &&
                    row33.item.chnageApprovalStatus == '1'
                  "
                >
                  <br />
                  Was Sent for Approval and got Approved
                </b>
                <b
                  v-if="
                    row33.item.chnageApprovalStatus &&
                    row33.item.chnageApprovalStatus == '2'
                  "
                >
                  <br />
                  Was Sent for Approval and got Rejected
                </b>
                <Add-Message
                  :fk_all_module_id="row33.item.allModuleId"
                  :fk_client_id="row33.item.clientId"
                  :fk_pod_id="row33.item.PODLocationId"
                  style="list-style-type: none"
                />
                <Overseas-CRDRNote
                  v-if="row33.item.jobType.indexOf('FF') < 0"
                  :title="row33.item.ccImportSeries"
                  :moduleType="'CC ' + row33.item.transportType + ' Module'"
                  :cr_all_module_id="row33.item.allModuleId"
                  :cr_jb_series="row33.item.ccImportSeries"
                  :cr_ass_date="row33.item.dateAssignment | moment"
                  :transportType="row33.item.transportType"
                  :Jobtype="'CC'"
                  :commonId="row33.item.ccImportId"
                  :shipmentType="
                    row33.item.shipmentType == '1' ||
                    row33.item.shipmentType == 'Sea_Shipment'
                      ? 'Sea'
                      : 'Air'
                  "
                  :isOverseas="false"
                  :ItemAr="null"
                />
              </template>
              <!-- <template slot="show_details" slot-scope="row">
                <b-form-checkbox
                  @change="row.toggleDetails"
                  v-model="row.detailsShowing"
                ></b-form-checkbox>
              </template> -->
              <!--   <template slot="row-details" slot-scope="row2">
                <b-card>
                  <b-button
                    size="sm"
                    @click="goToDoc(row2.item.ccImportId)"
                    variant="outline-info"
                    >View Documents
                    <br />
                  </b-button>
                  <div class="mt-2" v-if="row2.item.PODLocationId==row2.item.fpodName">
                    <b class="mt-3">Pre -Alert Date :</b>
                    {{row2.item.preAlertDate!=null?'Completed':'Pending'}}
                    <br>
                    <b>BoE Date :</b>
                    {{row2.item.preAlertDate==null?'--':row2.item.preAlertDate!='' && row2.item.billEntryDate==null?'Pending':'Completed'}}
                    <br>
                    <b>Vessel Arriving Date :</b>
                    {{row2.item.preAlertDate==null ?'--':row2.item.preAlertDate!='' && row2.item.vesselFinalDate==null?'Pending':'Completed'}}
                    <br>
                    <b>DO :</b>
                    {{(row2.item.preAlertDate==null || row2.item.billEntryDate==null || row2.item.vesselFinalDate==null) ?'--':row2.item.preAlertDate!='' && row2.item.billEntryDate!='' && row2.item.vesselFinalDate!='' && row2.item.doReleaseDate==null?'Pending':'Completed'}}
                    <br>
                    <b>Duty Paid Date :</b>
                    {{row2.item.preAlertDate==null || row2.item.billEntryDate==null || row2.item.vesselFinalDate==null ?'--':row2.item.preAlertDate!='' && row2.item.billEntryDate!='' && row2.item.vesselFinalDate!='' && row2.item.receivedDo==null?'Pending':'Completed'}}
                    <br>
                    <b>Out of Charge:</b>
                    {{row2.item.preAlertDate==null || row2.item.billEntryDate==null || row2.item.vesselFinalDate==null || row2.item.doReleaseDate==null || row2.item.receivedDo==null ?'--':row2.item.preAlertDate!='' && row2.item.billEntryDate!='' && row2.item.vesselFinalDate!='' && row2.item.doReleaseDate!='' && row2.item.receivedDo!='' && row2.item.outOfChargeDate==null?'Pending':'Completed'}}
                    <br>
                    <b>Empty Return Date:</b>
                    {{row2.item.preAlertDate==null || row2.item.billEntryDate==null || row2.item.vesselFinalDate==null || row2.item.doReleaseDate==null || row2.item.receivedDo==null || row2.item.outOfChargeDate==null ?'--':row2.item.preAlertDate!='' && row2.item.billEntryDate!='' && row2.item.vesselFinalDate!='' && row2.item.doReleaseDate!='' && row2.item.receivedDo!='' && row2.item.outOfChargeDate!='' && row2.item.ContainerNo==null && row2.item.emptyReturnDate==''?'Pending':row2.item.ContainerNo.split(',').length==row2.item.emptyReturnDate.split(',').length?'Completed':'Pending'}}
                  </div>
                  <div v-else>
                    <b>Pre -Alert Date :</b>
                    {{row2.item.preAlertDate!=null?'Completed':'Pending'}}
                    <br>
                    <b>Vessel ETA :</b>
                    {{row2.item.preAlertDate==null?'--':row2.item.preAlertDate!='' && row2.item.vesselEta==null?'Pending':'Completed'}}
                    <br>

                    <b>Rail Out:</b>
                    {{row2.item.preAlertDate==null || row2.item.vesselEta==null ?'--':row2.item.preAlertDate!='' && row2.item.vesselEta!='' && row2.item.railOutDate==null?'Pending':row2.item.ContainerNo.split(',').length==row2.item.railOutDate.split(',').length?'Completed':'Pending'}}
                    <br>
                    <b>ICD Arrival Date :</b>
                    {{row2.item.preAlertDate==null || row2.item.vesselEta==null ?'--':row2.item.preAlertDate!='' && row2.item.vesselEta!='' && row2.item.arrivalDate==null?'Pending':row2.item.ContainerNo.split(',').length==row2.item.arrivalDate.split(',').length?'Completed':'Pending'}}
                    <br>
                    <b>BoE date :</b>
                    {{row2.item.preAlertDate==null || row2.item.vesselEta==null || row2.item.railOutDate==null || row2.item.arrivalDate==null ?'--':row2.item.preAlertDate!='' && row2.item.vesselEta!='' && (row2.item.ContainerNo.split(',').length==row2.item.arrivalDate.split(',').length) && row2.item.billEntryDate==null?'Pending':'Completed'}}
                    <br>
                    <b>Duty Paid Date:</b>
                    {{row2.item.preAlertDate==null || row2.item.vesselEta==null || row2.item.railOutDate==null || row2.item.arrivalDate==null || row2.item.billEntryDate==null ?'--':row2.item.preAlertDate!='' && row2.item.vesselEta!='' && (row2.item.ContainerNo.split(',').length==row2.item.arrivalDate.split(',').length) && row2.item.billEntryDate!=null && row2.item.receivedDo==null?'Pending':'Completed'}}
                    <br>
                    <b>DO Date:</b>
                    {{row2.item.preAlertDate==null || row2.item.vesselEta==null || row2.item.railOutDate==null || row2.item.arrivalDate==null || row2.item.billEntryDate==null || row2.item.receivedDo==null ?'--':row2.item.preAlertDate!='' && row2.item.vesselEta!='' && (row2.item.ContainerNo.split(',').length==row2.item.arrivalDate.split(',').length) && row2.item.billEntryDate!=null && row2.item.doReleaseDate==null?'Pending':'Completed'}}
                    <br>
                    <b>Out of Charge Date:</b>
                    {{row2.item.preAlertDate==null || row2.item.vesselEta==null || row2.item.railOutDate==null || row2.item.arrivalDate==null || row2.item.billEntryDate==null || row2.item.receivedDo==null || row2.item.doReleaseDate==null ?'--':row2.item.preAlertDate!='' && row2.item.vesselEta!='' && (row2.item.ContainerNo.split(',').length==row2.item.arrivalDate.split(',').length) && row2.item.billEntryDate!=null && row2.item.doReleaseDate!=null && row2.item.outOfChargeDate==null?'Pending':'Completed'}}
                    <br>
                    <b>ICD Out Date:</b>
                    {{row2.item.preAlertDate==null || row2.item.vesselEta==null || row2.item.railOutDate==null || row2.item.arrivalDate==null || row2.item.billEntryDate==null || row2.item.receivedDo==null || row2.item.doReleaseDate==null || row2.item.outOfChargeDate==null ?'--':row2.item.preAlertDate!='' && row2.item.vesselEta!='' && (row2.item.ContainerNo.split(',').length==row2.item.arrivalDate.split(',').length) && row2.item.billEntryDate!=null && row2.item.doReleaseDate!=null && row2.item.outOfChargeDate!=null && row2.item.icdOutDate==''?'Pending':row2.item.ContainerNo.split(',').length==row2.item.icdOutDate.split(',').length?'Completed':'Pending'}}
                    <br>
                    <b>Empty Return Date:</b>
                    {{row2.item.preAlertDate==null || row2.item.vesselEta==null || row2.item.railOutDate==null || row2.item.arrivalDate==null || row2.item.billEntryDate==null || row2.item.receivedDo==null || row2.item.doReleaseDate==null || row2.item.outOfChargeDate==null ?'--':row2.item.preAlertDate!='' && row2.item.vesselEta!='' && (row2.item.ContainerNo.split(',').length==row2.item.arrivalDate.split(',').length) && row2.item.billEntryDate!=null && row2.item.doReleaseDate!=null && row2.item.outOfChargeDate!=null && (row2.item.emptyReturnDate=="" )?'Pending':row2.item.ContainerNo.split(',').length==row2.item.emptyReturnDate.split(',').length?'Completed':'Pending'}}
                  </div>
                </b-card>
              </template> -->
              <!-- <template slot="containerTypeName" slot-scope="row50">
                    <div v-if="row50.item.containerTypeName!=null">
                      <div v-if="row50.item.containerTypeName!=null">
                        <span
                          v-for="(item2,index) in row50.item.containerTypeName.split(',')"
                          :key="index"
                        >
                          <h6>
                            <b-badge variant="light">{{item2==''?'-------':item2}}</b-badge>
                          </h6>
                        </span>
                      </div>
                    </div>
                    <div v-else>
                      <b-badge variant="light">-------</b-badge>
                    </div>
              </template>-->
              <template slot="ffRailOutId" slot-scope="row3">
                <b
                  v-if="designation == 'superviser' && departmentName == 'Port/ICD'"
                  :style="
                    row3.item.ffRailOutId == null || row3.item.ffRailOutId == ''
                      ? { color: 'red' }
                      : { color: 'green' }
                  "
                  >{{
                    row3.item.ffRailOutId == "" || row3.item.ffRailOutId == null
                      ? "Pending"
                      : "Completed"
                  }}</b
                >
              </template>
              <!-- <template slot="ccImportId" slot-scope="row9">
                <md-button @click="viewExportAirPage(row9.item)">
                  <a class="fa fa-pencil-square-o"></a>
                </md-button>
              </template>-->
            </b-table>
          </div>
          <div>
            <h5>
              <b-pagination
                limit="5"
                align="center"
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="totalRows"
                @change="onPageChange($event)"
              ></b-pagination>
            </h5>
          </div>
        </div>
      </b-card-text>
    </b-card>
    <div>
      <b-modal
        size="xl"
        class="modal-dialog-doc"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        title=""
      >
        <div v-if="ALLMODULE">
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal"
          >Close
        </b-button>
      </b-modal>

      <!-- Added By Priyanshu Singh For Billing Close Section Start -->
      <b-modal
        id="modal-lock-conf"
        ref="modal-lock-conf"
        title="Reason for Open Locked Assignment"
        centered
        no-close-on-esc
        no-close-on-backdrop
        hide-footer
      >
        <h3>Confirmation</h3>
        <form ref="form">
          <b-form-group
            label="Remark"
            label-for="name-input"
            invalid-feedback="Name is required"
          >
            <b-form-textarea
              :formatter="capitalizeAll"
              rows="5"
              id="name-input"
              v-model="lockReason"
              required
            ></b-form-textarea>
          </b-form-group>
        </form>
        <b-button @click="closeLockUnLockConfirm" variant="danger"> Cancel</b-button>
        <b-button
          v-if="lockReason"
          :disabled="lock_button ? true : false"
          variant="success"
          class="pull-right"
          @click="ConfLock"
          >Send</b-button
        >
      </b-modal>
      <!-- Added By Priyanshu Singh For Billing Close Section End -->
      <md-dialog-confirm
        :md-content-html="alert.content"
        :md-ok-text="alert.ok"
        ref="addPop"
      ></md-dialog-confirm>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";

import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import DocForm from "../../component/allModuleForm/docLibrary.vue";
import AddMessage from "../../component/allModuleForm/addMessage.vue";
import AssignmentSummary from "../../component/common/assignmentSummary.vue";
import OverseasCRDRNote from "../common/overseasCRDRNote.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import AssignmentSplitMergeSummary from "../common/AssignmentSplitMergeSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import RejectInvTallyBillSummary from "../common/moduleBasedRejectInvTallyBillSummary.vue";
import MSDeleteRequest from "../common/MSDeleteRequest.vue";

export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    if (globalPermissionStatus("Custom Clearance")) {
      this.checkUserLoginTime();
      this.$store.dispatch("setCurrentRoute", "/CCImport/CCImportDetails");
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.viewFFExportFCL("0", "0", "1", "1");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      lock_allModuleId: "",
      lock_ffExportFclId: "",
      lock_ffExportFclSeries: "",
      lock_Type: "",
      lockReason: "",
      lock_button: false,
      is_locked: "",
      locked_counter: "",

      billingFilter: "",
      invoiceStatusList: [
        {
          inv: "1",
          int: "In-Progress",
        },
        {
          inv: "2",
          int: "Sent to Accounts",
        },
        {
          inv: "3",
          int: "Billing Not Started",
        },
        {
          inv: "",
          int: "All",
        },
      ],
      ALLMODULE: "",
      JOBSERIES: "",
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      totalRows: 1000000000000000,
      currentPage: 1,
      perPage: 10,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      fields: [
        {
          key: "seenExec",
          mainkey: "seenExec",
          label: "Sr No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "ccImportSeries",
          mainkey: "ccImportSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "Importer",
          mainkey: "clientName",
          label: "Client / Importer Name",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "Exporter",
          mainkey: "clientName",
          label: " Exporter Name",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "validBookingNo",
          mainkey: "validBookingNo",
          label: "Booking No",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "ContainerNo",
          mainkey: "ContainerNo",
          label: "Container No.",
          sortable: true,
          sortDirection: "ASC",
          table: "M.",
        },
        // {
        //   key: "containerTypeName",
        //   mainkey: "containerTypeName",
        //   label: "Container Type",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "A."
        // },

        {
          key: "placeRecp",
          mainkey: "pickupLocation",
          label: "Place of Receipt",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "LoadPort",
          mainkey: "pickupLocation",
          label: "Load Port",
          sortable: true,
          sortDirection: "ASC",
          table: "I.",
        },
        {
          key: "placeDis",
          mainkey: "pickupLocation",
          label: "Port of Discharge",
          sortable: true,
          sortDirection: "ASC",
          table: "E.",
        },
        {
          key: "finalPlace",
          mainkey: "pickupLocation",
          label: "Final Place of Delivery",
          sortable: true,
          sortDirection: "ASC",
          table: "H.",
        },
        {
          key: "shippingBillNo",
          mainkey: "shippingBillNo",
          label: "BOE Details",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "invoiceStatus",
          mainkey: "invoiceStatus",
          label: "Invoice Status",
          sortable: true,
          sortDirection: "ASC",
        },

        // {
        //   key: "show_details",
        //   mainkey: "billEntryDate",
        //   label: "More Details",
        //   sortable: true,
        //   sortDirection: "ASC",
        // },

        // {
        //   key: "ccImportId",
        //   mainkey: "ccImportId",
        //   label: "",
        //   sortable: true,
        //   sortDirection: "ASC"
        // }
      ],
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      pending_preAlrt_Count: 0,
      pending_emptyR_Count: 0,
      pending_vesselEta_Count: 0,
      pending_icdArrive_Count: 0,
      pending_railOut_Count: 0,
      pending_Do_Count: 0,
      pending_VesselArrive_Count: 0,
      pending_outCharge_Count: 0,
      pending_icdOut_Count: 0,
      isLoading: false,
      designation: "",
      departmentName: "",
      debounce: null,
      AirImportData: [],

      dateStatusFilter: "60",
      dateStatusList: [
        {
          inv: "60",
          int: "2 Month",
        },
        {
          inv: "90",
          int: "3 Month",
        },
        {
          inv: "125",
          int: "4 Month",
        },
        {
          inv: "186",
          int: "6 Month",
        },
        {
          inv: "248",
          int: "8 Month",
        },
        {
          inv: "300",
          int: "10 Month",
        },
        {
          inv: "367",
          int: "1 Year",
        },
        {
          inv: "734",
          int: "2 Year",
        },

        {
          inv: "0",
          int: "Global ALL",
        },
      ],
    };
  },

  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DocForm,
    ModelListSelect,
    AddMessage,
    AssignmentSummary,
    OverseasCRDRNote,
    ContainerSummary,
    JobWisePaymentsDetails,
    RejectInvTallyBillSummary,
    MSDeleteRequest,
  },

  computed: {},

  methods: {
    checkUserLoginTime() {
      // Fetch the user's login time from your database or wherever you store it
      const userLoginTime = new Date(this.$sessionsStorage.get("cc_imp_job_pendency"));
      const currentTime = new Date();
      const compareTime = 3 * 60 * 60 * 1000;

      // Calculate the time difference in milliseconds
      const timeDifference = currentTime - userLoginTime;

      // If the time difference is greater than 3 hours (in milliseconds)
      // if (timeDifference > 3 * 60 * 60 * 1000) {
      if (timeDifference > compareTime) {
        // Redirect the user to another page using Vue Router
        this.$router.push("/ccImpPendency");
      }
    },
    ConfLock() {
      if (this.lockReason) {
        this.isLoading = true;
        let tit = "";
        if (this.is_locked == 1) {
          this.is_locked = "0";
          tit = "Un-Locked";
        } else if (this.is_locked == 1) {
          this.is_locked = "1";
          tit = "Locked";
        }
        this.lock_button = true;
        let payload = {
          allModuleId: this.lock_allModuleId,
          lockReason: this.lockReason,
          update_keyVal: this.lock_ffExportFclId,
          assigmnmentSeries: this.lock_ffExportFclSeries,
          Type: this.lock_Type,
          is_locked: this.is_locked,
          locked_counter: this.locked_counter,
          table_name: "cc_import",
          update_key: "ccImportId",
          Title: tit,
          module_type: "CC Import",
        };
        // return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Common/locknnlockStatus.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.find == 1) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              this.$refs["addPop"].open();
              this.viewFFExportFCL("0", "1", "1");
              this.lock_button = false;
              this.isLoading = false;
            }
            (this.lockReason = ""), this.$refs["modal-lock-conf"].hide();
          })
          .catch((error) => {});
      }
    },
    LockUnLock(items, type) {
      this.lock_allModuleId = items.allModuleId;
      this.lock_ffExportFclId = items.ccImportId;
      this.lock_ffExportFclSeries = items.ccImportSeries;
      this.lock_Type = type;
      this.is_locked = items.is_locked;
      this.locked_counter = items.locked_counter;
      console.log("Priyanshu Singh=>", items);
      // return false;
      this.$refs["modal-lock-conf"].show();
    },
    closeLockUnLockConfirm() {
      this.$refs["modal-lock-conf"].hide();
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.viewFFExportFCL("0", "0", "1", "1");

        // this.typing = null
        // this.message = event.target.value
      }, 1000);
    },
    showDocModal(item) {
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.allModuleId;
      this.JOBSERIES = item.ccImportSeries;
      console.log(this.ALLMODULE);
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewFFExportFCL("0", CURRENT, "2", event);
    },
    goToDoc(ID) {
      this.$router.push({
        path: "/CCImport/ccDocListPage/" + ID + "/Import",
      });
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.viewFFExportFCL("0", CURRENT, "2", event);

      // let totalRows = 1064 / this.perPage;
      // if(this.totalRow )
    },
    goToMain() {
      this.$sessionsStorage.set("editCcImportId", "");
      this.$router.push({
        path: "/ccImport/CCImportEntry",
      });
    },
    JqueryFun() {
      return $(function () {
        return $("#conBooking").DataTable();
      });
    },

    viewExportAirPage(item) {
      let SEEN = item.seenExec;
      let AIR = item.ccImportId;
      this.$sessionsStorage.set("editCcImportId", AIR);
      this.$sessionsStorage.set("editCcType", "Import");

      if (SEEN != "1") {
        let paylod = {
          UpdateNotSeenToSeen: "yes",
          ccImportId1: AIR,
        };
        console.log(paylod);
        let options = {
          method: "POST",
          url: `${URL_BASE}/updateExecutionToSeenAllModules.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
            }
          })
          .catch((error) => {});
      }

      if (this.designation == "superviser" && this.departmentName == "Port/ICD") {
        this.$router.push({
          path: "/ccImport/ccHandoverToRail",
        });
      } else {
        if (item.newContainerFlow == "1") {
          this.$router.push({
            path: "/ccImport/newCCImportEntry",
          });
        } else {
          this.$router.push({
            path: "/ccImport/CCImportEntry",
          });
        }
      }
    },
    handleRefresh() {
      this.viewFFExportFCL("0", "0", "1", "1");
    },
    viewFFExportFCL(filterIdD, CURRENT, SEARCH, pageNumber) {
      this.AirImportData = [];
      this.isLoading = true;
      let payload = {
        searchVal: this.filter,
        fields: this.fields,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        view: "view",
        DCfilterId: filterIdD,
        dateStatusFilter: this.dateStatusFilter,
        billingFilter: this.billingFilter,
        optTypeTransport: this.$sessionsStorage.get("optTypeTransport")
          ? this.$sessionsStorage.get("optTypeTransport")
          : "",
        optAllModuleIdTransport: this.$sessionsStorage.get("optAllModuleIdTransport")
          ? this.$sessionsStorage
              .get("optAllModuleIdTransport")
              .replace(/^,/, "")
              .replace(/,$/, "")
          : "",
      };
      console.log(payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Custom/viewCCImportList_NewV3_VP.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            this.totalRows = data.totalData;
            if (SEARCH != "2") {
              this.currentPage = 1;
              if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
                this.currentPage = parseInt(this.lastVisitPage);
              }
            } else {
              this.currentPage = pageNumber;
            }
            this.pending_preAlrt_Count = parseInt(data.pending_preAlrt_Count);
            this.pending_vesselEta_Count = parseInt(data.pending_vesselEta_Count);
            this.pending_emptyR_Count = parseInt(data.pending_emptyR_Count);
            this.pending_icdArrive_Count = parseInt(data.pending_icdArrive_Count);
            this.pending_railOut_Count = parseInt(data.pending_railOut_Count);
            this.pending_icdOut_Count = parseInt(data.pending_icdOut_Count);
            this.pending_Do_Count = parseInt(data.pending_Do_Count);
            this.pending_outCharge_Count = parseInt(data.pending_outCharge_Count);
            this.pending_VesselArrive_Count = parseInt(data.pending_VesselArrive_Count);

            if (data.SeaConImportDetails.length > 0) {
              this.AirImportData = data.SeaConImportDetails;
            }

            if (data.UserDetail.length > 0) {
              this.designation = data.UserDetail[0].designation;
              if (this.designation == "superviser") {
                this.fields.push({
                  key: "ffRailOutId",
                  mainkey: "ffRailOutId",
                  label: "Port Status",
                  sortable: true,
                  sortDirection: "ASC",
                });
              }

              let filter1 = data.UserDetail[0].departmentName1.split(",").filter((x) => {
                return x == "Port/ICD";
              });

              this.departmentName = filter1.length > 0 ? "Port/ICD" : "fdsf";
            }

            this.JqueryFun();
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// viewCCImportDetails.vue?42e055ec